<template>
  <v-container>
    <v-row>
      <v-col cols="12">
          
        <v-btn absolute dark bottom fab right color="success" to="/meetups/new" v-if="!getLoadingStatus">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <div class="text-center" v-if="getLoadingStatus">
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>

        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Картинка</th>
                <th class="text-left">Время</th>
                <th class="text-left">Комната</th>
                <th class="text-left">Продолжительность</th>
                <th class="text-left">Дополнительная информация</th>
                <th class="text-left" v-if="userIsAuthenticated">Удалить</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="meetup in meetups" :key="meetup.id">
                <td><img :src="meetup.image" width="50"></td>
                <td>{{ meetup.timestamp | timestampToDateTime }}</td>
                <td>{{ meetup.room }}</td>
                <td>{{ meetup.duration }}</td>
                <td>{{ meetup.description }}</td>
                <td v-if="userIsAuthenticated">
                  <v-btn icon color="red lighten-3" @click="deleteMeetup(meetup.id)">
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        
      </v-col>
    </v-row> 
  </v-container>
</template>

<script>


  export default {
    data: () => ({

    }),
    methods:{
      deleteMeetup(id){
        this.$store.dispatch('deleteMeetup', id);
      }
    },
    computed: {
      meetups(){
        return this.$store.getters.loadedMeetups;
      },
      getLoadingStatus(){
        return this.$store.getters.loading;
      },
      userIsAuthenticated(){
        this.$store.dispatch('userIsAuthenticated');
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
      }
    },
    created(){
      this.$store.dispatch('loadMeetups');
    }
  }

</script>

<style scoped>

</style>
